export const TrackingEvents = Object.freeze({
	LEAD: 'scoreapp_lead',
	LEAD_FORM_MODAL_OPENED: 'scoreapp_lead_form_modal_opened',
	QUESTIONS_STARTED: 'scoreapp_questions_started',
	QUESTION_ANSWERED: 'scoreapp_question_answered',
	QUESTIONS_FINISHED: 'scoreapp_questions_finished',
	LEAD_DETAILS_UPDATED: 'scoreapp_lead_details_updated',
})
